
import engine from './Home.vue'

const VueChartEngine = {
	engine
}

module.exports = VueChartEngine;



// WEBPACK FOOTER //
// ./src/index.js